import activeDimensions from './active_dimensions';
import appConfig from './app_config';
import company from './company';
import constants from './constants';
import dashboard from './dashboard';
import messenger from './messenger';
import reducer from './reducer';
import scheduleConfig from './schedule_config';
import selectedIds from './selected_ids';
import selectedViews from './selected_view';
import styleGuide from './style_guide';
import task from './task';
import toasts from './toasts';

export default {
  activeDimensions,
  appConfig,
  company,
  constants,
  dashboard,
  messenger,
  reducer,
  scheduleConfig,
  selectedIds,
  selectedViews,
  styleGuide,
  task,
  toasts,
};
